import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  PLATFORM_ID,
  ViewChild,
  DOCUMENT
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { UntypedFormGroup } from '@angular/forms';
import { CustomHubspotForm } from './custom-hubspot-form.form';
import { HubspotFacadeService } from '@core/services/hubspot-facade.service';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { CaptchaComponent } from '@shared/components/captcha/captcha.component';
const FORM_STORAGE_KEY = 'contactUsFormData';
@Component({
    selector: 'mflooring-custom-hubspot-form',
    templateUrl: './custom-hubspot-form.component.html',
    styleUrls: ['./custom-hubspot-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CustomHubspotFormComponent {
	@Input() portalId: string;
	@Input() formId: string;
	@ViewChild('captchaComponent') captchaComponent: CaptchaComponent;

	public form: UntypedFormGroup = CustomHubspotForm();
	public loading = false;
	public submitStatus = new BehaviorSubject<boolean>(false);
	public isCaptchaValid = false;
	private pauseSave = false;
	constructor(
		@Inject(DOCUMENT) private documentRef: Document,
		@Inject(PLATFORM_ID) private platformId: string,
		private hubspotFacade: HubspotFacadeService,
		private cdr: ChangeDetectorRef
	) {}
	ngOnInit(): void {
		this.loadFormDataFromLocalStorage();

		this.form.valueChanges.subscribe(() => {
			this.saveFormDataToLocalStorage();
		});
	}
	private saveFormDataToLocalStorage() {
		if (this.pauseSave) return;
		try {
			const existingRaw = localStorage.getItem(FORM_STORAGE_KEY);
    		const existingData = existingRaw ? JSON.parse(existingRaw) : {};
			const { firstName, email } = this.form.value;
			const updatedData = {
			...existingData,
			...(firstName ? { firstName } : {}),
			...(email ? { email } : {})
			};
			localStorage.setItem(FORM_STORAGE_KEY, JSON.stringify(updatedData));
		} catch (err) {
			console.error('Error saving form data:', err);
		}
	}
	private loadFormDataFromLocalStorage() {
		try {
			const saved = localStorage.getItem(FORM_STORAGE_KEY);
			if (saved) {
				this.form.patchValue(JSON.parse(saved),{ emitEvent: false });
				this.cdr.detectChanges();
			}
		} catch (err) {
			console.error('Error loading form data:', err);
		}
	}


	get firstName() {
		return this.form.get('firstName');
	}

	get email() {
		return this.form.get('email');
	}

	get captcha() {
		return this.form.get('captcha');
	}

	onCaptchaValid(isValid: boolean): void {
		this.isCaptchaValid = isValid;
		this.cdr.detectChanges();
	}

	onSubmit() {
		if (!this.form.valid || !this.isCaptchaValid) {
			return;
		}

		this.loading = true;

		this.hubspotFacade
			.submitFooterEmailSubscription$(
				this.portalId,
				this.formId,
				this.firstName.value,
				this.email.value
			)
			.pipe(
				finalize(() => {
					this.loading = false;
					this.cdr.detectChanges();
				})
			)
			.subscribe(
				(response) => {
					console.log('Form submitted successfully', response);
					this.submitStatus.next(true);
					this.pauseSave = true;
					this.form.reset();
					setTimeout(() => (this.pauseSave = false), 200);
					if (this.captchaComponent) {
						this.captchaComponent.refreshCaptcha();
					}
					this.isCaptchaValid = false;
					this.cdr.detectChanges();
				},
				(error) => {
					console.error('Form submission error', error);
					if (error.error?.message?.includes('RECAPTCHA')) {
						console.error('Hubspot form has reCAPTCHA enabled. Please disable it in Hubspot form settings.');
					}
					this.cdr.detectChanges();
				}
			);
	}
}
